import { useEffect, useState, useCallback } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import GoldRateDropdown from "./GoldRateDropdown/GoldRateDropdown";
import SilverRateDropdownComponent from "./SilverRateDropdown/SilverRateDropdown";
import {
  MenuOutlined,
  CloseOutlined,
  SunOutlined,
  MoonOutlined,
} from "@ant-design/icons";
import "./header.css";
import AOS from "aos";
import "aos/dist/aos.css";


export default function Header() {
  const [isMenuClicked, setIsMenuClicked] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 758);
  const [darkMode, setDarkMode] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("dark-mode");
    } else {
      document.body.classList.remove("dark-mode");
    }
  }, [darkMode]);

  const handleMenu = useCallback(() => {
    setIsMenuClicked((prev) => !prev);
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 758px)");
    const handleResize = () => setIsMobile(mediaQuery.matches);
    mediaQuery.addEventListener("change", handleResize);
    return () => mediaQuery.removeEventListener("change", handleResize);
  }, []);

  const handleNavItemClick = () => {
    if (isMobile) {
      setIsMenuClicked(false);
    }
  };

  return (
    <div className="headerContainer">
      <div className="headerLeft">
        {isMobile && (
          <div className="menuIcon" onClick={handleMenu} data-aos="fade-right">
            {isMenuClicked ? (
              <CloseOutlined style={{ fontSize: "30px", color: "white" }} />
            ) : (
              <MenuOutlined style={{ fontSize: "30px", color: "white" }} />
            )}
          </div>
        )}

        <div className="logoContainer">
          <img src={ "./assets/Logo/logo1.webp"} alt="Vimal Jewellers Logo" className="logoImage" />
          <div className="headerTitleContainer">
            <h2 className="jai-guru-text">VIMAL JEWELLERS</h2>
            <div className="locationContainer">
              <span className="tamil-text">
                வருங்காலத்தில் வளமுடன் வாழ,<br />
                இப்பொழுதே சேமிப்போம் தங்கமாக!
              </span>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`navbarContent ${isMobile && !isMenuClicked ? "hidden" : "slide-in"}`}
        data-aos="fade-left"
      >
        <div
          className="darkModeToggle"
          onClick={() => setDarkMode(!darkMode)}
          role="button"
          aria-label="Toggle Dark Mode"
        >
          {darkMode ? <SunOutlined className="dark-mode-icon" /> : <MoonOutlined className="dark-mode-icon" />}
        </div>

        <GoldRateDropdown data-aos="fade-down" />
        <SilverRateDropdownComponent data-aos="fade-down" />

        <NavLink to="/home" onClick={handleNavItemClick} className="nav-link">
          <li className="NavItem">Home</li>
        </NavLink>
        <NavLink to="/about" onClick={handleNavItemClick} className="nav-link">
          <li className="NavItem">About</li>
        </NavLink>
        <NavLink to="/contact" onClick={handleNavItemClick} className="nav-link">
          <li className="NavItem">Contact</li>
        </NavLink>
      </div>
    </div>
  );
}
